import '../styles/SolutionsComponent.css';
import '../styles/JobsComponent.css';
//import CVFormComponent from "./CVFormComponent";

const JobsComponent = ({jobsContent}) => {
  if (!jobsContent || !jobsContent.jobs) {
    return null;
  }
  
  const { title, description, jobs } = jobsContent;

  const mid = Math.ceil(jobs.length / 2);
  const leftColumn = jobs.slice(0, mid);
  const rightColumn = jobs.slice(mid);

  const renderSolution = (item, index, isRightColumn = false) => (
    <div className="col mb-4" key={index}>
      <div className="row align-items-center">
        <div className="col-auto">
          <img
            src={item.icon}
            alt={item.heading}
            className="img-fluid"
            style={{ maxWidth: '30px' }}
          />
        </div>
        <div className="col">
          <h3
            className="title"
            id="jobs-heading"
            style={{
              fontSize: 25,
              color: '#ffffffff',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
              fontWeight: 'bold'
            }}
          >
            {item.heading}
          </h3>
        </div>
      </div>
      <div className="row">
        <p
          className="text"
          id="jobs-text"
          style={{
            fontSize: 13,
            color: '#ffffffff',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
            textAlign: isRightColumn ? 'right' : 'left'
          }}
        >
          {item.description}
        </p>
      </div>
    </div>
  );

  return (
    <div className="container">
      <div className="row" id="solutions">
        <div className="col">
          <div className="row">
            <h2
              className="my-4 title"
              id="jobs-title"
              style={{
                color: '#ffffffff',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                fontWeight: '900'
              }}
            >
              {title}
            </h2>
          </div>
          <div className="row mb-4">
            <h3
            className="my-4 title"
            id="jobs-desc"
              style={{
                color: '#ffffffff',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                fontWeight: '400',
                fontSize: 18,
              }}>
                {description}
            </h3>
              {/** <CVFormComponent /> */}
          </div>
          <div className="row">
            <div className="col-md-6">
              {leftColumn.map((item, idx) => renderSolution(item, idx, false))}
            </div>
            <div className="col-md-6">
              {rightColumn.map((item, idx) => renderSolution(item, idx, true))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobsComponent;